module.exports = __webpack_public_path__ + "static/media/tag.bc42fe38.svg";